(() => {
  const root = document.documentElement;
  root.dataset.lumaType = 'mixed';
  const keys = { colour: 'luma-colour' };
  const choices = { colour: ['cyan', 'pink', 'silver'], type: ['mixed'] };
  const setPreference = (kind, value, persist = true) => {
    if (!choices[kind].includes(value)) return;
    root.dataset[kind === 'colour' ? 'lumaColour' : 'lumaType'] = value;
    if (persist) { try { localStorage.setItem(keys[kind], value); } catch {} }
    document.querySelectorAll(`button[data-luma-${kind}]`).forEach(button => button.setAttribute('aria-pressed', String(button.dataset[kind === 'colour' ? 'lumaColour' : 'lumaType'] === value)));
    if (kind === 'colour') {
      const api = window.tidioChatApi;
      try { if (api && typeof api.setColorPalette === 'function') api.setColorPalette(getComputedStyle(root).getPropertyValue('--luma-accent').trim()); } catch {}
    }
  };
  for (const kind of Object.keys(keys)) {
    let value = choices[kind][0];
    try { value = localStorage.getItem(keys[kind]) || value; } catch {}
    setPreference(kind, choices[kind].includes(value) ? value : choices[kind][0], false);
  }
  const isBlue = (r, g, b) => b > r * 1.35 && g > r * 1.25 && g > 55 && b > 65;
  const convertColours = text => text.replace(/#([\da-f]{6}|[\da-f]{3})(?![\da-f])/gi, (match, digits) => {
    if (digits.length === 3) digits = [...digits].map(x => x + x).join('');
    const [r, g, b] = [0, 2, 4].map(i => parseInt(digits.slice(i, i + 2), 16));
    return isBlue(r, g, b) ? 'var(--luma-accent)' : match;
  }).replace(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(\s*,\s*[^)]+)?\)/gi, (match, r, g, b, alpha) => isBlue(+r, +g, +b) ? (alpha ? `rgba(var(--luma-accent-rgb)${alpha})` : 'rgb(var(--luma-accent-rgb))') : match);
  const normalise = scope => {
    const styles = scope.matches?.('style:not([data-luma-palette])') ? [scope] : scope.querySelectorAll?.('style:not([data-luma-palette])') || [];
    styles.forEach(style => { const next = convertColours(style.textContent); if (next !== style.textContent) style.textContent = next; });
    const inline = scope.matches?.('[style],svg [fill],svg [stroke]') ? [scope] : scope.querySelectorAll?.('[style],svg [fill],svg [stroke]') || [];
    inline.forEach(el => {
      const svg = el.closest('svg');
      if (svg) {
        const colours = new Set([...svg.querySelectorAll('[fill],[stroke]'), svg].flatMap(node => ['fill','stroke'].map(attr => node.getAttribute(attr)?.toLowerCase())).filter(value => value && value !== 'none' && value !== 'currentcolor'));
        if (colours.size > 1) return;
      }
      ['style', 'fill', 'stroke'].forEach(attr => {
      const original = el.getAttribute(attr);
      if (!original) return;
      const next = convertColours(original);
      if (next !== original) el.setAttribute(attr, next);
      });
    });
  };
  const ready = () => {
    normalise(document);
    for (const kind of Object.keys(keys)) setPreference(kind, root.dataset[kind === 'colour' ? 'lumaColour' : 'lumaType'], false);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'attributes') normalise(record.target);
      else record.addedNodes.forEach(node => { if (node.nodeType === 1) normalise(node); });
    })).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'fill', 'stroke'] });
    document.addEventListener('click', event => {
      const toggle = event.target.closest('[data-luma-drawer]');
      if (toggle) {
        const id = toggle.dataset.lumaDrawer === 'colour' ? 'LumaColourDrawer' : 'LumaTypeDrawer';
        const drawer = document.getElementById(id);
        if (drawer && !drawer.open) {
          drawer.showModal();
          const anchor = toggle.getBoundingClientRect();
          const panel = { width: drawer.offsetWidth, height: drawer.offsetHeight };
          drawer.style.left = `${Math.max(16, Math.min(anchor.left + (anchor.width - panel.width) / 2, window.innerWidth - panel.width - 16))}px`;
          drawer.style.top = `${Math.max(16, Math.min(anchor.bottom + 12, window.innerHeight - panel.height - 16))}px`;
          drawer.style.right = 'auto';
        }
        return;
      }
      const close = event.target.closest('[data-luma-close]');
      if (close) close.closest('dialog').close();
      for (const kind of Object.keys(keys)) {
        const option = event.target.closest(`button[data-luma-${kind}]`);
        if (option) {
          setPreference(kind, option.dataset[kind === 'colour' ? 'lumaColour' : 'lumaType']);
          option.closest('dialog').close();
        }
      }
      if (event.target.matches('dialog.luma-appearance-drawer')) {
        const box = event.target.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
      }
    });
    window.addEventListener('storage', event => {
      for (const kind of Object.keys(keys)) if (event.key === keys[kind]) setPreference(kind, event.newValue || choices[kind][0], false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
})();
